export default __webpack_public_path__ + "static/media/General news logo (2).cf5683d2.png";